import { FC } from "react";
import { FieldValues, useController, UseControllerProps } from "react-hook-form";

export function withController<T>(Component: FC<T>) {
  return function ControlledComponent<U extends FieldValues>({
    name,
    control,
    defaultValue,
    disabled,
    rules,
    shouldUnregister,
    formatValue,
    ...props
  }: T & UseControllerProps<U> & { formatValue?: (value: string) => string }) {
    const {
      field: { disabled: disabledState, name: nameState, onChange, ...controllerRest },
      fieldState: { error: fieldError }
    } = useController({ name, control, defaultValue, disabled, rules, shouldUnregister });

    const handleOnChange = (e: React.ChangeEvent<any>) => {
      if (formatValue) {
        const formattedValue = formatValue(e.target.value);
        onChange(formattedValue);
        return;
      }
      onChange(e);
    };

    return <Component disabled={disabledState} name={nameState} error={fieldError?.message} onChange={handleOnChange} {...controllerRest} {...(props as T)} />;
  };
}
